<template>
  <div class="dea-loader">
    <Lottie :options="defaultOptions" :height="300" :width="300" @animCreated="handleAnimation" />
  </div>
</template>

<script>
import Lottie from "vue-lottie"; // eslint-disable-line import/no-extraneous-dependencies

export default {
  name: "Loader",
  components: {
    Lottie,
  },
  props: {
    fileName: {
      type: String,
      default: "loader",
    },
  },
  data() {
    return {
      defaultOptions: null,
      animationSpeed: 1,
    };
  },
  created() {
    // eslint-disable-next-line global-require, import/no-dynamic-require
    const animationData = require(`../../assets/animations/${this.fileName}.json`);
    this.defaultOptions = { animationData };
  },
  methods: {
    handleAnimation(anim) {
      this.anim = anim;
      this.anim.play();
    },
  },
};
</script>

<style lang="scss">
.dea-loader {
  margin: auto;
}
</style>
